import { EventEmitter } from 'events';

export type AuthSessionInvalidatedPayload = {
	reason?: string;
	message?: string;
	/** Set when reason === 'banned': ISO date of a temporary ban's end, null when permanent. */
	expiresAt?: string | null;
	banReason?: string;
};

const AUTH_SESSION_INVALIDATED_EVENT = 'auth:session-invalidated';
const emitter = new EventEmitter();

export const authSessionEvents = {
	emitInvalidated(payload: AuthSessionInvalidatedPayload = {}) {
		emitter.emit(AUTH_SESSION_INVALIDATED_EVENT, payload);
	},
	subscribe(listener: (payload: AuthSessionInvalidatedPayload) => void) {
		emitter.on(AUTH_SESSION_INVALIDATED_EVENT, listener);
		return () => {
			emitter.off(AUTH_SESSION_INVALIDATED_EVENT, listener);
		};
	},
};
